import { ErrorMessage, Field, Form, FormikProvider, useFormik } from 'formik'
import React, { useEffect, useState } from 'react'
import { Container } from 'react-bootstrap'
import * as bie from "react-bootstrap";
import CommonFormHeading from '../../CommonUtils/CommonFormHeading';
import { ERROR_MSG } from '../../CommonUtils/contextVariables';
import Swal from 'sweetalert2';
import { config } from '../../CommonUtils/CommonURLS';
import { CommonAxiosGet, CommonAxiosPost } from '../../CommonUtils/CommonAxios';
import { failureAlert, successAlert2 } from '../../CommonUtils/SweetAlerts';
import * as Yup from 'yup';
import { useDispatch } from 'react-redux';
import { BiTrash } from 'react-icons/bi';
import { FaEdit } from 'react-icons/fa';
import { allowAlphabetAndSpacesOnly } from '../../CommonUtils/CommonValidations';

export default function AddSubComponent() {
    const [componentlist, setcomponentList] = useState([]);
    const [subComponentlist, setsubComponentList] = useState([]);
    const [showErrorMsg, setErrorMsg] = useState(false)
    const [editsubcompData, seteditsubcompData] = useState(null);
    const [RowSubCompId,setRowSubCompId]=useState("")
    const [snovalue,setsnovalue]=useState("")
    const dispatch = useDispatch();
    const subcomponentFormik = useFormik({
        initialValues: {
            sno:"",
            compId: "",
            subCompId: "",
            subCompName: "",
            description: ""
        },
        validationSchema: Yup.object({
            compId: Yup.string().required(ERROR_MSG).nullable(),
            subCompName: Yup.string().required(ERROR_MSG).nullable(),
            description: Yup.string().required(ERROR_MSG).nullable()
        }),
        onSubmit: (values) => {
            const finalvalues={
                ...values,
                subCompId:RowSubCompId === null || RowSubCompId === undefined || RowSubCompId === "" ? values?.subCompId :RowSubCompId,
                sno:snovalue
            }
            Swal.fire({
                text: 'Are you sure you want to submit?',
                icon: 'warning',
                showCancelButton: true,
                confirmButtonText: 'Yes, submit it!',
                cancelButtonText: 'No, cancel!',
                backdrop: false,
            }).then((result) => {
                if (result.isConfirmed) {
                    const url = `${config.url.API_URL}saveSubComponent`;
                    CommonAxiosPost(url, finalvalues).then((res) => {
                        if (res?.data?.scode === '01') {
                            Swal.fire({
                                text: res?.data?.sdesc,
                                icon: 'success',
                                confirmButtonText: 'OK',
                                backdrop: false,
                            }).then((resdayfordiff) => {
                                if (resdayfordiff?.isConfirmed === true) {
                                    subcomponentFormik.setFieldValue("compId", "");
                                    subcomponentFormik.setFieldValue("subCompId", "");
                                    subcomponentFormik.setFieldValue("subCompName", "");
                                    subcomponentFormik.setFieldValue("description", "");
                                    seteditsubcompData(null)
                                    GetSubComponentList();
                                }
                            });

                        } else {
                            failureAlert(res?.data?.sdesc);
                        }
                    });
                } else {
                    console.log('Submission canceled');
                }
            });
        }
    })
    function GetComponentList() {
        let url = config.url.API_URL + `componentdetails`;
        CommonAxiosGet(url).then((res) => {
            console.log("list>",res?.data)
            if (res?.data?.scode === '01') {
                setcomponentList(res?.data?.componentDetails);
            }
            else {
                setcomponentList([]);
            }
        })
    }
    function GetSubComponentList() {
        let suburl = config.url.API_URL + `subComponentDetails`;
        CommonAxiosGet(suburl).then((res) => {
            if (res?.data?.scode === '01') {
                setsubComponentList(res?.data?.subComponentDetails);
                setErrorMsg(false)
            }
            else {
                setsubComponentList([]);
                setErrorMsg(true)
            }
        })
    }
    function EditSubComponent(row) {
        setsnovalue(row?.sno)
      setRowSubCompId(row.comp_id)
       subcomponentFormik.setFieldValue("sno", row.sno);
        subcomponentFormik.setFieldValue("compId", row.comp_id);
        subcomponentFormik.setFieldValue("subCompId", row?.sub_comp_id);
        subcomponentFormik.setFieldValue("subCompName", row?.sub_comp_name);
        subcomponentFormik.setFieldValue("description", row?.description);
    }

    function UpdateSubComponent(updateformikvalues) {
        Swal.fire({
            text: 'Are you sure you want to update?',
            icon: 'warning',
            showCancelButton: true,
            confirmButtonText: 'Yes',
            cancelButtonText: 'No',
            backdrop: false,
        }).then((result) => {
            if (result.isConfirmed) {
                console.log("updateformikvalues", updateformikvalues)
                const url = config.url.API_URL + "updateSubComponent";
                CommonAxiosPost(url, updateformikvalues).then((res) => {
                    if (res?.data?.scode === '01') {
                        successAlert2(res?.data?.sdesc);
                        Swal.fire({
                            text: res?.data?.sdesc,
                            icon: 'success',
                            confirmButtonText: 'OK',
                            backdrop: false,
                        }).then((resdayfordiff) => {
                            if (resdayfordiff?.isConfirmed === true) {
                                subcomponentFormik.setFieldValue("compId", "");
                                subcomponentFormik.setFieldValue("subCompId", "");
                                subcomponentFormik.setFieldValue("subCompName", "");
                                subcomponentFormik.setFieldValue("description", "");
                                seteditsubcompData(null)
                                GetSubComponentList();
                            }
                        });

                    } else {
                        failureAlert(res?.data?.sdesc);
                    }
                });
            } else {
                console.log('Submission canceled');
            }
        });
    }

    function DeleteSubComponent(sno) {
        Swal.fire({
            text: 'Are you sure you want to delete?',
            icon: 'warning',
            showCancelButton: true,
            confirmButtonText: 'Yes',
            cancelButtonText: 'No',
            backdrop: false,
        }).then((result) => {
            if (result.isConfirmed) {
                const url = config.url.API_URL + "deletesubComponent?sno=" + sno;
                CommonAxiosPost(url, dispatch).then((res) => {
                    if (res?.data?.scode === '01') {

                        Swal.fire({
                            text: res?.data?.sdesc,
                            icon: 'success',
                            confirmButtonText: 'OK',
                            backdrop: false,
                        }).then((resdayfordiff) => {
                            if (resdayfordiff?.isConfirmed === true) {
                                GetSubComponentList();
                            }
                        });

                    } else {
                        failureAlert(res?.data?.sdesc);
                    }
                });
            } else {
                console.log('Submission canceled');
            }
        });
    }
    useEffect(() => { GetComponentList(); GetSubComponentList() }, [])
    return (
        <div>
            <Container className="outer-page-content-container shadow-none px-3 m-0 mw-100 pb-3" >
                <CommonFormHeading heading="Sub Component" />
                <FormikProvider value={subcomponentFormik}>
                    <Form onSubmit={subcomponentFormik.handleSubmit} onChange={subcomponentFormik.handleChange}>
                        <bie.Row className='pt-1'>
                            <bie.Col xs={12} sm={12} md={12} lg={3} xl={3} xxl={3}>
                                <label className="label-text-style mb-1"><b style={{ color: 'red' }}>* </b>Component</label>
                                <Field as="select" className='form-control' name='compId' disabled={editsubcompData}
                                onChange={()=>{subcomponentFormik.setFieldValue("subCompId", "");
                                subcomponentFormik.setFieldValue("subCompName", "");
                                subcomponentFormik.setFieldValue("description", "");
                                setRowSubCompId("")}}>
                                    <option value="">--Select--</option>
                                    {componentlist !== undefined && componentlist.map((c, i) => {
                                        return <option key={i} value={c.comp_id}>{c.comp_name}</option>
                                    })}
                                </Field>
                                <ErrorMessage name="compId" component="div" className="text-error" />
                            </bie.Col>
                            <bie.Col xs={12} sm={12} md={12} lg={3} xl={3} xxl={3}>
                                <label className="label-text-style mb-1"><b style={{ color: 'red' }}>* </b>Sub Component</label>
                                <Field type="text" className="form-control" name="subCompName" onKeyPress={(e) => { allowAlphabetAndSpacesOnly(e); }} maxLength="250" />
                                <ErrorMessage name="subCompName" component="div" className="text-error" />
                            </bie.Col>
                            <bie.Col xs={12} sm={12} md={12} lg={3} xl={3} xxl={3}>
                                <label className="label-text-style mb-1"><b style={{ color: 'red' }}>* </b>Description</label>
                                <Field as="textarea" name="description" className="form-control mb-2" maxLength="350" />
                                {/* <Field type="text" className="form-control" name="description" onKeyPress={(e) => { allowAlphabetAndSpacesOnly(e); }} maxLength="250" /> */}
                                <ErrorMessage name="description" component="div" className="text-error" />
                            </bie.Col>
                            <bie.Col xs={12} sm={12} md={12} lg={1} xl={1} xxl={1} >
                                {/* {editsubcompData ?
                                    <button type="button" className="btn btn-success btn-sm float-end mt-4" onClick={() => {
                                        UpdateSubComponent(subcomponentFormik?.values)
                                    }}>Update</button> :} */}
                                    <button type="submit" className="btn btn-success btn-sm float-end mt-4">Submit</button>

                            </bie.Col>
                        </bie.Row>
                    </Form>
                </FormikProvider>
                <center>
                    {subComponentlist.length > 0 ?
                        <div className="table-responsive mt-4">
                            <table className="table table-condensed table-bordered  table-responsive affl-table" >
                                <thead>
                                    <tr>
                                        <th>S.No</th>
                                        <th>Component Name</th>
                                        <th>Sub Component Name</th>
                                        <th>Description</th>
                                        <th>Edit</th>
                                        <th>Delete</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {subComponentlist && subComponentlist?.map((cmp, index) => (<>
                                        <tr key={index}>
                                            <td>{index + 1}</td>
                                            <td style={{ textAlign: "left" }}>{cmp?.comp_name} </td>
                                            <td style={{ textAlign: "left" }}>{cmp?.sub_comp_name} </td>
                                            <td style={{ textAlign: "left" }}>{cmp?.description} </td>
                                            <td>
                                                <button type="button" className="btn btn-primary btn-sm" onClick={() => {
                                                    EditSubComponent(cmp)
                                                    seteditsubcompData(true)
                                                }}> <FaEdit size={18} /></button>
                                            </td>
                                            <td>
                                                <button type="button" className="btn btn-danger btn-sm"
                                                    onClick={() => { DeleteSubComponent(cmp.sno) }}>
                                                    <BiTrash />
                                                </button>
                                            </td>
                                        </tr>
                                    </>))}

                                </tbody>
                            </table>

                        </div> : showErrorMsg === true ? (<center><b style={{ color: "red" }}>*********No Data Found*********</b></center>) : ("")}
                </center>
            </Container>
        </div>
    )
}
